import React from 'react';
import ContactUs from '../components/ContactUs';

const ContactPage: React.FC = () => {
  return (
    <>
      <ContactUs />
      
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-left">
            <h2>Additional Information</h2>
            <p className="footer-tagline">
              We're committed to providing exceptional legal representation with integrity and compassion.
            </p>
          </div>
          
          <div className="footer-right">
            <div className="footer-info">
              <h3 className="footer-info-title">Quick Links</h3>
              <div className="footer-info-item">
                <span className="footer-info-label">Home:</span>
                <a href="/" className="footer-info-value" style={{ cursor: 'pointer' }}>Return to Homepage</a>
              </div>
              <div className="footer-info-item">
                <span className="footer-info-label">Email:</span>
                <span className="footer-info-value">admin@muselegalgroup.com</span>
              </div>
              <div className="footer-info-item">
                <span className="footer-info-label">Phone:</span>
                <span className="footer-info-value">818-245-8888</span>
              </div>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p className="footer-copyright">© 2025 Muse Legal Group. All rights reserved.</p>
          <div className="footer-brand">MUSE LEGAL</div>
        </div>
      </footer>
    </>
  );
};

export default ContactPage;

